export const CRUSH_MULT = 1.25;

export type RoasZone = "below" | "profitable" | "well-above";

export const computeBreakevenRoas = (profitMarginPercent: number): number => {
  const marginDecimal = profitMarginPercent / 100;
  if (marginDecimal <= 0) {
    return 0;
  }
  return 1 / marginDecimal;
};

export const computeCrushLine = (breakevenRoas: number): number =>
  breakevenRoas * CRUSH_MULT;

export const computeScaleMax = (
  yourRoas: number | null,
  breakevenRoas: number
): number => {
  const crushLine = computeCrushLine(breakevenRoas);
  const cand = Math.max(yourRoas ?? 0, crushLine, 1);
  return Math.max(4, Math.ceil((cand * 1.18) / 2) * 2);
};

export const roasToPercent = (roas: number, scaleMax: number): number =>
  (roas / scaleMax) * 100;

export const getRoasZone = (
  roas: number,
  breakevenRoas: number,
  crushLine: number
): RoasZone => {
  if (roas < breakevenRoas) {
    return "below";
  }
  if (roas < crushLine) {
    return "profitable";
  }
  return "well-above";
};

export const formatRoas = (value: number): string => `${value.toFixed(1)}x`;
